export default __webpack_public_path__ + "34c7bdd937c06309d7ee02486ffb5121.jpg";